var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-layout"},[(!_vm.loading)?[_c('transition',{attrs:{"name":"router"}},[_c('router-view')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }